import { DanoneDnProductFamily } from '../entities/danone-dn-product-family';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';


export class DanoneDnProductFamilyRequest extends BaseRequest {
  
  danoneDnProductFamily : DanoneDnProductFamily;

  constructor(userInfo : UserInfo){    
    super(userInfo);
  }

}

